<template>
  <ul><li></li><li></li><li></li></ul>
</template>

<script>
  export default {
    name: 'NavToggle'
  }
</script>

<style lang="scss" scoped>

  @import "~globals";

  ul {
    @include list-style-reset;
    width:20+12px; padding:6px; cursor:pointer; z-index:6;
    @media print {
      display:none;
    }
    &:hover li, &:focus li {
      background-color:$color-primary;
    }
  }

  li {
    display:block; height:3px; background-color:#000; transform-origin:50% 50%; border-radius:2px; transition:all 450ms;
  }

  li+li {
    margin-top:3px;
  }

  .active {
    li {
      &:nth-child(2) {
        opacity:0;
      }
      &:first-child {
        transform:rotate3d(0,0,1,45deg) translate3d(4px, 5px, 0);
      }
      &:last-child {
        transform:rotate3d(0,0,1,-45deg) translate3d(4px, -5px, 0);
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/AppHeader/NavToggle.vue